import { render, staticRenderFns } from "./PageAnalysis.vue?vue&type=template&id=ede5cb90&scoped=true"
import script from "./PageAnalysis.vue?vue&type=script&lang=js"
export * from "./PageAnalysis.vue?vue&type=script&lang=js"
import style0 from "./PageAnalysis.vue?vue&type=style&index=0&id=ede5cb90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede5cb90",
  null
  
)

export default component.exports